<template>
    <div class="layout">
        <div class="header">
            <div class="header-left">
                <img class="header-logo" src="@/assets/sys/login/logo.png" alt="" />
            </div>

            <div class="header-user">
                <img src="@/assets/home/default_avatar.png" alt="">
                <span>{{userInfo.name}}</span>
                <span @click="handleExit">退出</span>
            </div>

            <div class="header-tabs">{{ activeMenuName }}</div>
        </div>

        <div class="header-mobile">
            <div class="header-mobile-menu" @click="handleShowMenu">
                <img src="@/assets/home/wap_more.png" alt="">
            </div>
            <img class="header-mobile-logo" src="@/assets/home/wap_logo.png" alt="">

            <div class="header-mobile-logout" @click="handleClickAvatar">
                <img src="@/assets/home/default_avatar_mobile.png" alt="">
            </div>

            <Popup v-model="isShowMenu" position="left" style="height: 100%">
                <div class="header-mobile-menuList">
                    <div class="header-mobile-subMenu" v-for="(subMenuItem, subMenuKey) in tabList" :key="subMenuKey">
                        <div class="header-mobile-subMenu-text">{{subMenuItem.name}}</div>
                        <div :class="`header-mobile-menuItem ${path === menuItem.router ? 'header-mobile-menuItem-active' : ''}`" v-for="(menuItem, menuKey) in subMenuItem.children" :key="menuKey" @click="handleSelectMenu(menuItem)">
                            {{menuItem.name}}
                        </div>
                    </div>
                </div>
            </Popup>

        </div>

        <div class="content">
            <div class="dataEffect">
                <div class="dataEffect-menu">
                    <Menu :default-active="activeMenu" @open="handleOpenMenu" @close="handleCloseMenu">
                        <div v-for="(subMenu, subMenuIndex) in tabList" :key="subMenuIndex">
                            <Submenu :index="subMenu.router" v-if="!subMenu.isItem">
                                <template slot="title">
                                    <div class="dataEffect-menu-submenu">
                                        <img class="dataEffect-menu-icon" :src="subMenu.icon" alt="">
                                        <span class="dataEffect-menu-name">{{ subMenu.name }}</span>
                                        <img :class="`dataEffect-menu-arrow ${openMenuList.indexOf(subMenu.router) > -1 ? 'dataEffect-menu-arrow-open' : ''}`" src="@/assets/home/triangle_close.png" alt="">
                                    </div>
                                </template>
                                <MenuItem v-for="(menuItem, menuItemIndex) in subMenu.children" :key="menuItemIndex" :index="menuItem.router" @click="handleClickMenu(menuItem)">
                                <div :class="`dataEffect-menuItem-name ${activeMenu === menuItem.router ? 'dataEffect-menuItem-name-active' : ''}`">{{ menuItem.name }}</div>
                                </MenuItem>
                            </Submenu>
                            <MenuItem v-else :index="subMenu.router" @click="handleClickMenu(subMenu)">
                            <template slot="title">
                                <div :class="`dataEffect-menu-submenu`">
                                    <img v-show="activeMenu !== subMenu.router" class="dataEffect-menu-icon" :src="subMenu.icon" alt="">
                                    <img v-show="activeMenu === subMenu.router" class="dataEffect-menu-icon" :src="subMenu.activeIcon" alt="">
                                    <span :class="`dataEffect-menu-name ${activeMenu === subMenu.router ? 'dataEffect-menu-name-active' : ''}`">{{ subMenu.name }}</span>
                                </div>
                            </template>
                            </MenuItem>
                        </div>

                    </Menu>
                </div>
                <div class="dataEffect-content">

                    <div class="layout-content">
                        <router-view />
                    </div>
                </div>

                <input style="position: fixed; bottom: -99999px" type="text" id="copyInput">
            </div>

        </div>

        <Dialog v-model="isShow" width="550px" title="当前登录用户" confirmText="退出登录" @cancel="isShow = false" @confirm="handleExit">
            <div class="exitDialog-text">{{userInfo.name}}</div>
        </Dialog>
    </div>
</template>

<script>
import { getTabList } from './config'
import { Message } from 'iview'
import router from '@/router'
import { isEmpty } from '@/utils/common'
import Dialog from '@/components/dialog/dialog.vue'
import Popup from 'vant/lib/popup'
import 'vant/lib/popup/style'
import { Menu, Submenu, MenuItemGroup, MenuItem } from 'element-ui';


export default {
    components: {
        Popup,
        Dialog,
        Menu,
        Submenu,
        MenuItemGroup,
        MenuItem
    },
    data() {
        return {
            tabList: getTabList(),
            tabIndex: 0,
            activeMenu: "",
            activeMenuName: "",
            openMenuList: [],
            userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
            isShowMenu: false,
            isShow: false,
            path: "",
            host: ""
        }
    },
    mounted() {
        this.host = location.host
        for (let i = 0; i < this.tabList.length; i++) {
            const tabItem = this.tabList[i]
            if (Array.isArray(tabItem.children) && tabItem.children.length) {
                for (let j = 0; j < tabItem.children.length; j++) {
                    const menuItem = tabItem.children[j]
                    if (menuItem.router === this.$route.path) {
                        this.tabIndex = i
                        this.activeMenu = menuItem.router
                        this.activeMenuName = menuItem.name
                    }
                }
            }

        }
        this.path = this.$route.path
    },
    beforeRouteEnter(to, from, next) {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
        if (!isEmpty(userInfo) && userInfo.token && userInfo.customerId) {
            next()
        } else {
            Message.error('请先登录')
            router.push('/')
        }
    },
    methods: {
        // 点击tab项时触发
        hanldeSelectTab(tabItem, tabKey) {
            if (Array.isArray(tabItem.children) && tabItem.children.length) {
                this.$router.push(tabItem.children[0].router)
            } else {
                this.$router.push(tabItem.router)
            }
            this.tabIndex = tabKey
        },

        // 处理显示菜单
        handleShowMenu() {
            this.isShowMenu = true
        },

        // 处理选择菜单事件
        handleSelectMenu(menuItem) {
            if (this.$route.path !== menuItem.router) {
                this.path = menuItem.router
                this.$router.push(menuItem.router)
            }
            this.isShowMenu = false
        },

        // 处理PC端选择菜单事件
        handleClickMenu(menuItem) {
            this.activeMenu = menuItem.router
            this.activeMenuName = menuItem.name
            this.$router.push(menuItem.router)
        },

        // 处理打开菜单事件
        handleOpenMenu(index) {
            if (this.openMenuList.indexOf(index) === -1) {
                this.openMenuList.push(index)
            }
        },

        // 处理关闭菜单事件
        handleCloseMenu(index) {
            const menuIndex = this.openMenuList.indexOf(index)
            if (menuIndex > -1) {
                this.openMenuList.splice(menuIndex, 1)
            }
        },

        // 处理点击头像事件
        handleClickAvatar() {
            this.isShow = true
        },

        // 点击退出按钮时触发
        handleExit() {
            localStorage.removeItem('userInfo')
            Message.success('退出登录成功')
            this.$router.push('/')
        }
    }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
    .layout {
        position: relative;
        height: 100%;
        width: 100%;
        min-height: 800px;
        padding-top: 70px;
        .header {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            height: 70px;
            background: #fff;
            //background: linear-gradient(90deg, #0061e4, #2379ee);
            .header-left {
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                width: 242px;
                background-color: #0072ff;
                .header-logo {
                    position: absolute;
                    left: 30px;
                    top: 22px;
                    width: 182px;
                    height: 26px;
                }
            }
            .header-user {
                position: absolute;
                right: 41px;
                > img {
                    width: 34px;
                    height: 34px;
                    vertical-align: middle;
                    margin-right: 10px;
                }
                > span:nth-child(2) {
                    font-size: 12px;
                    color: #333;
                    line-height: 70px;
                }
                > span:nth-child(3) {
                    margin-left: 20px;
                    font-size: 12px;
                    color: #666;
                    cursor: pointer;
                }
            }
            .header-tabs {
                position: absolute;
                left: 242px;
                top: 0;
                padding-left: 40px;
                font-size: 16px;
                line-height: 70px;
                color: #333;
            }
        }

        .header-mobile {
            display: none;
        }
        .content {
            height: 100%;
            .dataEffect {
                height: 100%;
                display: flex;
                flex-direction: row;
            }

            .dataEffect-menu {
                min-width: 242px;
                height: 100%;
                padding-top: 30px;
                background-color: #fff;
                .dataEffect-menu-submenu {
                    position: relative;
                    padding-left: 10px;
                }
                .dataEffect-menu-icon {
                    width: 14px;
                    height: 16px;
                }
                /deep/ .el-menu {
                    border-right-color: #eff3f8;
                    .el-menu-item.is-active {
                        background-color: #eff3f8;
                    }
                    .el-submenu__icon-arrow {
                        display: none;
                    }
                }
                .dataEffect-menu-name {
                    margin-left: 14px;
                    font-size: 14px;
                    color: #333;
                }
                .dataEffect-menuItem-name {
                    padding-left: 22px;
                    font-size: 12px;
                    color: #666;
                }
                .dataEffect-menu-name-active,
                .dataEffect-menuItem-name-active {
                    color: #0072ff;
                }
                .dataEffect-menu-arrow {
                    display: block;
                    position: absolute;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    width: 9px;
                    height: 9px;
                    margin: auto 0;
                    transition: all 0.15s;
                }

                .dataEffect-menu-arrow-open {
                    transform: rotate(90deg);
                }
            }

            .dataEffect-content {
                position: relative;
                display: flex;
                flex-direction: column;
                width: calc(100% - 242px);
                height: 100%;
                border-radius: 10px;
                background-color: #f7f7f7;

                .dataEffect-content-breadcrumb {
                    z-index: 2;
                    position: absolute;
                    left: 20px;
                    right: 20px;
                    top: 0;
                    background-color: #f7f7f7;
                }
                .layout-content {
                    overflow-y: auto;
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0px;
                    bottom: 0;
                    padding: 20px 40px 40px 20px;
                    background-color: #eff3f8;
                }
            }

            @media screen and (max-width: 768px) {
                .dataEffect {
                    flex-direction: column;
                }
                .dataEffect-menu {
                    display: none;
                }
                .dataEffect-content {
                    width: 100%;
                    .dataEffect-content-breadcrumb {
                        display: none;
                    }
                    .layout-content {
                        height: 100%;
                        position: relative;
                        padding: 0;
                    }
                }
            }
        }
        >>> .el-table {
            th.el-table__cell {
                background-color: #eef1f6;
                border-color: #eef1f6;
            }
            .cell {
                padding: 0 10px;
                font-size: 12px;
                line-height: 27px;
            }
            .el-table__cell {
                padding: 10px 0;
                border-bottom: none;
                border-color: #fff;
            }
            .el-table__row--striped .el-table__cell {
                background-color: #f3f6fb;
                border-color: #f3f6fb;
            }
            .hover-row .el-table__cell {
                background-color: #f5f7fa;
            }
            .el-table__fixed::before {
                background-color: #fff;
            }
            .el-table__body-wrapper {
                z-index: 2;
            }
        }
        >>> .el-table::before {
            background-color: #fff;
        }
    }
}

@media screen and (max-width: 768px) {
    .layout {
        position: relative;
        height: 100%;
        width: 100%;
        background-color: #f7f7f7;
        .header {
            display: none;
        }
        .content {
            height: 100%;
            .dataEffect {
                height: 100%;
            }
            .dataEffect-content {
                height: 100%;
            }
            .layout-content {
                height: 100%;
            }
            .dataEffect-menu {
                display: none;
            }
        }
        .header-mobile {
            z-index: 9;
            position: fixed;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 0 0.15rem;
            top: 0;
            left: 0;
            right: 0;
            height: 0.9rem;
            background-color: #008fe8;
            .header-mobile-menu {
                padding: 0.15rem;
                > img {
                    width: 0.3rem;
                    height: 0.27rem;
                }
            }
            .header-mobile-logo {
                width: 1.94rem;
                height: 0.28rem;
            }
            .header-mobile-logout {
                padding: 0.15rem;
                > img {
                    width: 0.44rem;
                    height: 0.44rem;
                }
            }
            .header-mobile-menuList {
                width: 5.6rem;
                height: 100%;
                overflow-y: auto;
                background-color: #fff;
                .header-mobile-subMenu {
                    padding: 0.5rem 0 0.5rem 0.6rem;
                    border-bottom: 0.02rem solid #e9f0f6;
                    .header-mobile-subMenu-text {
                        font-size: 0.34rem;
                        line-height: 0.34rem;
                        color: #333;
                    }
                    .header-mobile-menuItem {
                        padding-left: 0.28rem;
                        margin-bottom: 0.8rem;
                        font-size: 0.3rem;
                        line-height: 0.28rem;
                        color: #666666;
                        transition: color 0.15s;
                    }
                    .header-mobile-menuItem-active {
                        color: #0061e4;
                    }
                    .header-mobile-menuItem:nth-child(2) {
                        margin-top: 0.7rem;
                    }
                    .header-mobile-menuItem:last-child {
                        margin-bottom: 0.1rem;
                    }
                }
                .header-mobile-subMenu:last-child {
                    border: none;
                }
            }
        }

        >>> .el-table {
            .el-table__header {
                .el-table__cell {
                    padding: 0;
                    height: 0.7rem;
                    background-color: #edf1f7;
                }
            }
            .el-table__row--striped .el-table__cell {
                background-color: #f2f6fc;
                border-color: #f2f6fc;
            }
        }
    }
}

.exitDialog-text {
    padding: 0 0.3rem;
    font-size: 0.32rem;
    text-align: center;
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/pages/home/index.vue